import React from "react";
import Button from "react-bootstrap/Button";
import useSessionInactivityTimeout from "../hooks/useSessionInactivityTimeout";
import ModalWrapper from "./ModalWrapper";
import { settings } from "../shim/jsbridge";

const SessionInactivityTimeout = () => {
  const { remainingTime, timeoutHandler, resetHandler, isPrompting } =
    useSessionInactivityTimeout(
      settings.SESSION_INACTIVITY_TIMEOUT_PERIOD,
      settings.SESSION_INACTIVITY_AUTOMATICALLY_LOGOUT
    );

  return (
    <ModalWrapper
      id={"session-inactivity-timeout-modal"}
      show={isPrompting}
      title="Session Timeout"
      onHide={resetHandler}
      footer={
        <>
          <Button onClick={timeoutHandler} variant="prompt-secondary">
            Log Out
          </Button>
          <Button onClick={resetHandler} variant="prompt-primary">
            Continue Session
          </Button>
        </>
      }
    >
      <p>Your session is about to expire due to inactivity.</p>
      <p>
        You will be logged out in <b>{remainingTime}</b> seconds
      </p>
    </ModalWrapper>
  );
};

export default SessionInactivityTimeout;
